(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bottom-cart-banner"]) return;
  try {
    
  /* Re-render this section when the theme's AJAX cart changes, preserving the open state. */
  (function () {
    var ID = 'bottom-cart-banner';
    var pending = false;
    var again = false;

    function refresh() {
      if (pending) {
        again = true;
        return;
      }
      pending = true;

      fetch(window.location.pathname + '?sections=' + ID, { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (sections) {
          pending = false;
          var container = document.getElementById('shopify-section-' + ID);

          if (sections && sections[ID] && container) {
            var wasOpen = !!container.querySelector('.cart-banner[open]');
            var parsed = new DOMParser().parseFromString(sections[ID], 'text/html');
            var incoming = parsed.getElementById('shopify-section-' + ID);
            container.innerHTML = incoming ? incoming.innerHTML : parsed.body.innerHTML;

            var banner = container.querySelector('.cart-banner');
            if (banner && wasOpen) banner.open = true;
          }

          if (again) {
            again = false;
            refresh();
          }
        })
        .catch(function () {
          pending = false;
          if (again) {
            again = false;
            refresh();
          }
        });
    }

    ['cart:updated', 'cart:refresh'].forEach(function (eventName) {
      document.documentElement.addEventListener(eventName, refresh);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
